import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import { LanguageProvider } from '@/hooks/useLanguage';
import { ROUTE_PATHS } from '@/lib/index';
import Home from '@/pages/Home';
import About from '@/pages/About';
import Business from '@/pages/Business';
import MedicalDevices from '@/pages/MedicalDevices';
import MineralsBusiness from '@/pages/MineralsBusiness';
import { CoffeeProducts, ThaiFruits, AILiveStreaming } from '@/pages/BusinessDetail';
import Partners from '@/pages/Partners';
import News from '@/pages/News';
import Contact from '@/pages/Contact';

function NotFound() {
  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="text-center">
        <h1 className="text-6xl font-bold text-primary mb-4">404</h1>
        <p className="text-muted-foreground mb-6">Page not found</p>
        <a href="/" className="text-primary hover:underline font-semibold">← Back to Home</a>
      </div>
    </div>
  );
}

export default function App() {
  return (
    <LanguageProvider>
      <Router>
        <Routes>
          <Route path={ROUTE_PATHS.HOME} element={<Home />} />
          <Route path={ROUTE_PATHS.ABOUT} element={<About />} />
          <Route path={ROUTE_PATHS.BUSINESS} element={<Business />} />
          <Route path={ROUTE_PATHS.BUSINESS_MEDICAL} element={<MedicalDevices />} />
          <Route path={ROUTE_PATHS.BUSINESS_COFFEE} element={<CoffeeProducts />} />
          <Route path={ROUTE_PATHS.BUSINESS_FRUITS} element={<ThaiFruits />} />
          <Route path={ROUTE_PATHS.BUSINESS_AI_LIVE} element={<AILiveStreaming />} />
          <Route path={ROUTE_PATHS.PARTNERS} element={<Partners />} />
          <Route path={ROUTE_PATHS.NEWS} element={<News />} />
          <Route path={ROUTE_PATHS.CONTACT} element={<Contact />} />
          <Route path="/business/minerals" element={<MineralsBusiness />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Router>
    </LanguageProvider>
  );
}
